import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { catchError, endWith, switchMap, takeWhile, tap } from 'rxjs/operators';
import { AtsResumeScreenService } from './ats-resume-screen.service';

@Injectable({
  providedIn: 'root'
})
export class AtsResumePollingService {

  constructor(private atsresumeservice: AtsResumeScreenService) { }

  startAtsPolling(jobid: string, intervalMs: number = 3000): Observable<any> {

    return timer(0, intervalMs).pipe(
      switchMap(() =>
        this.atsresumeservice.syncCandidate(jobid).pipe(
          catchError(err => {
            return of({ data: { progress: 0 } });
          })
        )
      ),

      tap((res: any) => {
        console.log('Polling progress:', res.body.data.progress);
      }),

      takeWhile(
        (res: any) =>
          res.body?.data?.progress < 100 ||
          res.body?.data?.status == 'failure' ||
          res.body?.data?.status == 'no-data'
      ),
      endWith({ body: { data: { progress: 100 } } })
    );
  }
}
